var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d5e3da43e71053218245f7953e87c08762169b80"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"d5e3da43e71053218245f7953e87c08762169b80"};
      